module.exports = __webpack_public_path__ + "static/media/Avatars_Female-01.c455836e.png";